/**
 * Formats a number with thousand separators using locale-aware formatting
 * @param {number|string|null|undefined} value - The value to format
 * @returns {string} Formatted number string with thousand separators, or "0" for invalid inputs
 * @example
 * formatNumber(123) // "123"
 * formatNumber(1234) // "1,234"
 * formatNumber(1000000) // "1,000,000"
 * formatNumber(null) // "0"
 * formatNumber(undefined) // "0"
 * formatNumber("abc") // "0"
 */
export const formatNumber = (value) => {
  // Handle null and undefined
  if (value === null || value === undefined) {
    return "0";
  }

  // Convert to number if it's a string
  const num = Number(value);

  // Return "0" if conversion results in NaN
  if (isNaN(num)) {
    return "0";
  }

  // Use toLocaleString for locale-aware thousand separators
  return num.toLocaleString();
};
